import { BasePublicApi } from '#packages/apilib';
import { ResizeGapsScope } from './resizeGapsScope';
import { findGapUnderCursor } from './findGapUnderCursor';
import {
  toggleResizeGapsUserPreferences,
  getResizeGapsUserPreferences,
} from './resizeGapsUserPreferences';
import { isEnabled } from './utils/isEnabled';

function tryShowGapBoxUnderCursor(scope: ResizeGapsScope) {
  const { editorAPI, resizeGapsStore } = scope;

  if (!isEnabled(scope)) {
    resizeGapsStore.clearGap();
    return;
  }

  const gap = findGapUnderCursor(editorAPI);
  if (gap) {
    resizeGapsStore.setGap(gap);
  } else {
    resizeGapsStore.clearGap();
  }
}

function hideGapBox(scope: ResizeGapsScope) {
  scope.resizeGapsStore.clearGap();
}

export class ResizeGapsApi extends BasePublicApi<ResizeGapsScope> {
  tryShowGapBoxUnderCursor = this.bindScope(tryShowGapBoxUnderCursor);
  hideGapBox = this.bindScope(hideGapBox);
  toggleResizeGapsUserPreferences = this.bindScope(
    toggleResizeGapsUserPreferences,
  );
  getResizeGapsUserPreferences = this.bindScope(getResizeGapsUserPreferences);
}
